import React from 'react';
import Storage from '../services/storage';
import { Link } from 'react-router-dom';

export class ClearCache extends React.Component<any> {
  timer: any;
  state = { status: 'Clearing local cache...' };

  clear = () => {
    this.timer = setTimeout(async () => {
      try {
        await Storage.clear();
        this.setState({ status: 'OK' });
      } catch (e) {
        this.setState({ status: `Error: ${e.message}` });
      }
    }, 1000);
  };

  componentDidMount() {
    this.clear();
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    return (
      <div className="page page--cache" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <h1>
          {this.state.status}
        </h1>
        <div>
          <Link to="/">HOME</Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ClearCache.tsx